import { render, staticRenderFns } from "./AccountKaiju.vue?vue&type=template&id=1d1ebe82&"
import script from "./AccountKaiju.vue?vue&type=script&lang=ts&"
export * from "./AccountKaiju.vue?vue&type=script&lang=ts&"
import style0 from "./AccountKaiju.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports